import {IDimOrientation, LayoutDimData, ResizeHelper} from "../../core/utils/ResizeHelper";
import {PunkRocker} from "../PunkRocker";
import {gsap} from "gsap";

export class GameLogo extends PIXI.Container {
    protected readonly logoDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(-148, 118.5),
        },
        portrait: {
            scale: new PIXI.Point(1.1, 1.1),
            position: new PIXI.Point(355, -100)
        }
    };

    protected _overlay: PIXI.Graphics;

    protected _logo: PIXI.Sprite;

    constructor() {
        super();
        this.name = "GameLogo";

        this.init();
    }

    onResize(): void {
        const dim: LayoutDimData = ResizeHelper.calcDim(this.logoDim);
        this._logo.scale = dim.scale;
        this._logo.position = dim.position;
        this._logo.visible = true;
        this.RePaint(-400, -480, 1680, 1680);
    }

    protected init(): void {
        this._overlay = new PIXI.Graphics();
        this.addChild(this._overlay);
        this._overlay.alpha = 0;

        this._logo = new PIXI.Sprite(PunkRocker.assetLoader.getTextures("Game_Logo")[0]);
        this._logo.anchor.set(0.5, 0.5);
        this.addChild(this._logo);

        this.onResize();
    }

    protected RePaint(posX: number, posY: number, width: number, height: number): void {
        this._overlay.clear();
        this._overlay.beginFill(0x000000, 1);
        this._overlay.drawRect(posX, posY, width, height);
        this._overlay.endFill();
    }

    public setBGAlpha(alphaFrom: number, alphaTo: number, durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        tl.fromTo(this._overlay, {
            alpha: alphaFrom
        }, {
            alpha: alphaTo,
            duration: durr
        });

        return tl;
    }
}